<script>
import { QBtn } from "quasar";
import { computed } from "vue";

export default {
    name: "QitButton",
    components: { QBtn },
    inheritAttrs: false,
    props: {
        ripple: {
            type: Boolean,
            default: false,
        },
        noCaps: {
            type: Boolean,
            default: true,
        },
        noWrap: {
            type: Boolean,
            default: true,
        },
        unElevated: {
            type: Boolean,
            default: true,
        },
        color: {
            type: String,
            default: "primary",
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { attrs }) {
        const effectiveSize = computed(() => {
            if (props.compact) return "12px";
            return attrs.size;
        });

        const effectivePadding = computed(() => {
            if (props.compact) return "sm";
            return attrs.padding;
        });

        const forwardedProps = computed(() => {
            // Pass all attrs except size and padding
            const { size: _size, padding: _padding, ...rest } = attrs;
            return rest;
        });

        return {
            effectiveSize,
            effectivePadding,
            forwardedProps,
        };
    },
};
</script>

<template>
    <q-btn
        v-bind="forwardedProps"
        :ripple="ripple"
        :no-caps="noCaps"
        :no-wrap="noWrap"
        :unelevated="unElevated"
        :color="color"
        :size="effectiveSize"
        :padding="effectivePadding"
    >
        <template v-for="name in Object.keys($slots)" :key="name" #[name]="slotData">
            <slot :name="name" v-bind="slotData || {}" />
        </template>
    </q-btn>
</template>
